import { useStore } from '../stores/useStore'

export function useBlendOrderId() {
  const blendId = useStore((state) => state.session?.blend_id)

  return blendId
}
